/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Unreadable_OneInputs */



/**
* | output |
* | --- |
* | "1 report could not be read, so it is excluded from the three totals above." |
*
* @param {Partner_Billing_Board_Unreadable_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_unreadable_one = /** @type {((inputs?: Partner_Billing_Board_Unreadable_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Unreadable_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Bericht konnte nicht gelesen werden und ist aus den drei Summen oben ausgenommen.")
	return /** @type {LocalizedString} */ ("1 report could not be read, so it is excluded from the three totals above.")
});